export const COUNTRIES = [
  { code: "+63", country: "ph", name: "Philippines" },
  { code: "+1", country: "us", name: "United States" },
  { code: "+44", country: "gb", name: "United Kingdom" },
  { code: "+81", country: "jp", name: "Japan" },
  { code: "+82", country: "kr", name: "South Korea" },
  { code: "+86", country: "cn", name: "China" },
  { code: "+65", country: "sg", name: "Singapore" },
  { code: "+60", country: "my", name: "Malaysia" },
  { code: "+66", country: "th", name: "Thailand" },
  { code: "+84", country: "vn", name: "Vietnam" },
  { code: "+62", country: "id", name: "Indonesia" },
  { code: "+61", country: "au", name: "Australia" },
  { code: "+64", country: "nz", name: "New Zealand" },
  { code: "+91", country: "in", name: "India" },
];

export const getFlagUrl = (code: string) =>
  `https://flagcdn.com/w40/${
    COUNTRIES.find((c) => c.code === code)?.country ?? "in"
  }.png`;
